import { useState, useRef, useEffect, SyntheticEvent, useCallback } from "react";
//--------------------------------------------------------------------------------------------
import redoImg from "src/img/sketches/redo.png";
import undoImg from "src/img/sketches/undo.png";
import clearImg from "src/img/sketches/clear.png";
import penImg from "src/img/sketches/pen.png";
import { globalProps } from "src/App";
import { useMyStore } from "src/components/main/mainStore";
import Modal from "src/components/common/modal";
import { 
    PicDataArr, 
    xyDataArr, 
    xyDataItem, 
    PicDataItem, 
    ss,
    cssjson,
    json
} from "src/components/common/types";
import {
    myAxios, 
    MyFormData, 
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function Esign({ 
    picData, 
    setPicData, 

    prefix, 
    id, 
    defaultSignId, 
    disableDefaultSign, 
    email, 
    buttonClassName, 
}:{ 
    picData: PicDataArr, 
    setPicData: ss<PicDataArr>, 

    prefix: string, 
    id: string, 
    defaultSignId: string, 
    disableDefaultSign: boolean, 
    email: string, 
    buttonClassName: string, 
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const curPicData:PicDataArr =  picData!;
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
        landscape: window.innerWidth > window.innerHeight
      });
      useEffect(() => {
        const handleOrientationChange = () => {
            setTimeout(() => {
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                    landscape: window.innerWidth > window.innerHeight
                });  
            }, 500);
            //window.orientation; //0, 90, -90, undefined
        }
        window.addEventListener("orientationchange", handleOrientationChange);
        return () => {
            window.removeEventListener("orientationchange", handleOrientationChange);
        }
      }, []);
    //--------------------------------------------------------------------------------------------
    let iconStyle2Index = 0;
    //--------------------------------------------------------------------------------------------
    const eraserRatio = 4;
    const [curId, setCurId] = useState(defaultSignId);
    const [drawMode, setDrawMode] = useState("pen");
    const [isMouseDown, setIsMouseDown] = useState(false);
    const [currentStep, setCurrentStep] = useState<xyDataArr>([]);
    const [undoData, setUndoData] = useState<PicDataArr>([]);
    const [startPos, setStartPos] = useState<xyDataItem>({x:0, y:0});
    const [atDefault, setDefualt] = useState(false);
    const [showModal, setShowModal] = useState(false);
    //--------------------------------------------------------------------------------------------
    const canvasRef = useRef(null);
    //--------------------------------------------------------------------------------------------
   const iconStyle2 = (index:number):cssjson => ({
        width: "40px", 
        position: "absolute", 
        top: `${-30 + 47 * index}px`, 
        right:  "23px", 
        padding: "5px"
    });
    const onMouseDown = (e: SyntheticEvent) => {
        setUndoData([]);
        setIsMouseDown(true);
        const canvas = e.currentTarget as HTMLCanvasElement;
        let mouseEvent;
        if(e.nativeEvent instanceof TouchEvent){
            if(e.nativeEvent.touches.length === 1){
                mouseEvent = e.nativeEvent.touches[0];
            }else{
                return;
            }
        }else if(e.nativeEvent instanceof MouseEvent){
            mouseEvent = e.nativeEvent;
        }
        const context = canvas!.getContext("2d");
        const rect = canvas.getBoundingClientRect(), 
        scaleX = canvas.width / rect.width,  
        scaleY = canvas.height / rect.height;
        const x = (mouseEvent?.clientX! - rect.left) * scaleX;
        const y = (mouseEvent?.clientY! - rect.top) * scaleY;
        context!.beginPath();
        switch(drawMode){
            case "pen":
                setStartPos({x: x , y: y});
                setCurrentStep([{x: x ,y: y}])
            break;
            case "eraser":
                context!.strokeStyle = "#fff";
                context!.lineWidth = eraserRatio;
                context!.lineCap = "round";
                setStartPos({x: x , y: y});
                setCurrentStep([{x: x ,y: y}])
            break;
            default:
        }
    }
    const onMouseMove = (e: SyntheticEvent) => {
        if(!isMouseDown) return;
        const canvas = e.currentTarget as HTMLCanvasElement;
        let mouseEvent;
        if(e.nativeEvent instanceof TouchEvent){
            if(e.nativeEvent.touches.length === 1){
                mouseEvent = e.nativeEvent.touches[0];
            }else{
                return;
            }
        }else if(e.nativeEvent instanceof MouseEvent){
            mouseEvent = e.nativeEvent;
        }
        const context = canvas!.getContext("2d");
        const rect = canvas!.getBoundingClientRect(),
        scaleX = canvas!.width / rect.width,
        scaleY = canvas!.height / rect.height;
        const x = (mouseEvent?.clientX! - rect.left) * scaleX;
        const y = (mouseEvent?.clientY! - rect.top) * scaleY;
        drawCanvas(curPicData || []);
        switch(drawMode){
            case "pen":
                context!.moveTo(startPos.x, startPos.y);
                currentStep.forEach(step => {context!.lineTo(step.x, step.y)});
                setCurrentStep([...currentStep, {x: x, y: y}]);
                context!.lineTo(x, y);
                context!.stroke();
            break;
            default:
        }
    }
    const onMouseUp = () => {
        setIsMouseDown(false);
        switch(drawMode){
            case "pen":
                setPicData([...curPicData, {
                    data: currentStep,
                    drawMode: "pen"
                }]);
                setDefualt(false);
                break;
            default:
        }
    }
    const onMouseOut = () => {
        if(!globalProps.isMouseDown) return;
        onMouseUp();
    }
    const onMouseOver = (e: SyntheticEvent) => {
        if(!globalProps.isMouseDown) return;
        onMouseDown(e);
    }
    const drawCanvas = useCallback((pD?: PicDataArr) => {
        const curPicData =  Array.isArray(picData)?picData:[];
        const localPD = pD ?? (curPicData || []);
        const canvas = canvasRef.current! as HTMLCanvasElement;
        if(canvas){
            const context = canvas!.getContext("2d");
            context!.clearRect(0, 0, canvas.width, canvas.height);
            localPD.forEach((currentPicData: PicDataItem) => {
                context!.beginPath();
                switch(currentPicData.drawMode){
                    case "pen":
                        context!.moveTo(currentPicData.data[0].x , currentPicData.data[0].y);
                        currentPicData.data.forEach((step: xyDataItem) => {
                            context!.lineTo(step.x, step.y);
                        })
                        context!.stroke();
                    break;
                    default:
                }
            })
            context!.beginPath();
        }
    }, [picData]);
    useEffect(() => {
        drawCanvas();
    }, [picData, windowSize])
    //--------------------------------------------------------------------------------------------
    return(
        <>
        <div className = {buttonClassName || "m-4"}>
            <span
                className = {`btn btn-${curPicData.length?"success":"primary"}`}
                onClick = {e => {
                    if(windowSize.height > windowSize.width){
                        window.alert("Please change to landscape view to sign.");
                        return;
                    }
                    e.currentTarget.blur();
                    setShowModal(true);
                }
            }>
                {
                curPicData.length?
                <>Edit Signature</>
                :
                <>Click to Sign</>
                }
            </span>
        </div>
        <Modal 
            show = {showModal && windowSize.height < windowSize.width?"":"none"}
            width = {"100%"} 
            title = {(prefix?prefix + " ":"") + "Signature"} 
            closeIt = {() => {
                setShowModal(false);
            }}
        >
        <section className = "esign">
            <div className = "my-3">
                <canvas
                    id = {`esign${id || ""}`}
                    ref = {canvasRef}
                    className = "block mx-auto noDefaultTouchAction border penCursor"
                    width = {(windowSize.landscape?windowSize.width:windowSize.height) - 106}
                    height = {(windowSize.landscape?windowSize.height:windowSize.width) * 0.6}
                    onMouseDown = {onMouseDown}
                    onMouseMove = {onMouseMove}
                    onMouseUp = {onMouseUp}
                    onMouseOut = {onMouseOut}
                    onMouseOver = {onMouseOver}
                    onTouchStart = {onMouseDown}
                    onTouchMove = {onMouseMove}
                    onTouchEnd = {onMouseUp}
                    onTouchCancel = {onMouseOut}
                />
            </div>
            <div className = "my-3">
                <img className = {`${drawMode === "pen"?"bg-primary":null} pointer rounded`} src = {penImg} alt = "" style = {iconStyle2(++iconStyle2Index)} onClick = {() => {
                    setDrawMode("pen");
                }}/>
                <img className = "pointer" src = {undoImg} alt = "" style = {iconStyle2(++iconStyle2Index)} onClick = {() => {
                    if(curPicData[0]){
                        setUndoData([...undoData, curPicData[curPicData.length - 1]]);
                        setPicData(curPicData.slice(0, -1));
                        setDefualt(false);
                    }
                }}/>
                <img className = "pointer" src = {redoImg} alt = "" style = {iconStyle2(++iconStyle2Index)} onClick = {() => {
                    if(undoData[0]){
                        setPicData([
                            ...curPicData, 
                            undoData[undoData.length - 1]
                        ]);
                        setUndoData(undoData.slice(0, -1));
                        setDefualt(false);
                    }
                }}/>
                <img className = "pointer" src = {clearImg} alt = "" style =  {iconStyle2(++iconStyle2Index)}  onClick = {() => {
                    if(!window.confirm("are you sure to clear all the drawings?")) return;
                    setPicData([]);
                    setDefualt(false);
                }}/>
            </div>
            <div className = "mb-3">
                    {!disableDefaultSign?<>
                    {curId?(!atDefault?
                    <span className = "btn btn-primary ml-3" onClick = {async () => {
                        const formData = new MyFormData();
                        formData.append("fileId", curId);
                        //-------------------------------------------------------------
                        setShowLoader(true);
                        const res: json | false = await myAxios("common/getJSONData.php", formData);
                        setShowLoader(false);
                        if(!res) return;
                        //-------------------------------------------------------------
                        setPicData(res.data);
                        setDefualt(true);
                    }}>
                        Use Default
                    </span>
                    :null
                    ):null}
                    {atDefault?null:<span className = "btn btn-info ml-3" onClick = {async () => {
                        if(!window.confirm("Are you sure to make the current draing your default signature?")) return;
                        const formData = new MyFormData();
                        formData.append("userEmail", email || user.email);
                        formData.append("signData", JSON.stringify(curPicData));
                        //-------------------------------------------------------------
                        setShowLoader(true);
                        const res: json | false = await myAxios("common/setDefaultSign.php", formData);
                        setShowLoader(false);
                        if(!res) return;
                        //-------------------------------------------------------------
                        setCurId(res.data);
                        setDefualt(true);
                    }}>
                        Set Default
                    </span>}
                    </>:null}
                </div> 
        </section>
        </Modal>
        </>
    )    
}